// ===============================
// pages/Categories.jsx
// ===============================

import React from "react";
import "./Categories.css";

const categories = [
  {
    id: 1,
    name: "Fashion",
    image:
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b",
  },
  {
    id: 2,
    name: "Electronics",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
  },
  {
    id: 3,
    name: "Furniture",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85",
  },
  {
    id: 4,
    name: "Beauty",
    image:
      "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9",
  },
];

const Categories = () => {
  return (
    <div className="categories-page">

      <div className="page-banner">
        <h1>Categories</h1>
      </div>

      <div className="container">

        <div className="categories-grid">

          {categories.map((item) => (

            <div
              className="category-card"
              key={item.id}
            >

              <img
                src={item.image}
                alt={item.name}
              />

              <div className="overlay">
                <h2>{item.name}</h2>
              </div>

            </div>

          ))}

        </div>

      </div>

    </div>
  );
};

export default Categories;